module.exports = function getResource (label, vars = []) {
    let resources = {
        orderTotal: 'Order Total',
        merchandiseSubtotal: 'Merchandise Subtotal',
        pointsUsed: 'Points Used',
        shippingAndHandling: 'Shipping & Handling',
        discounts: 'Discounts',
        giftWrap: 'Gift wrap',
        gstOrHst: 'GST/HST',
        pst: 'PST',
        tax: 'Tax',
        storeCreditRedeemed: 'Account Credit',
        giftCardRedeemed: 'Gift Card Redeemed',
        eGiftCardRedeemed: 'eGift Card Redeemed',
        creditCardPayment: 'Credit Card Payment',
        payPalPayment: 'PayPal Payment',
        viewOrCancel: 'To view or cancel your order, go to',
        orderDetails: 'order details',
        pickup: 'Pickup',
        free: 'FREE'
    };
    return resources[label];
};
